import React, { useContext, useEffect, useState } from 'react';
import './AdminDashboardPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import TableProviderRAGReport from "root/Tables/TableProviderRagReport";
import { getProviderSectionRAGReport } from "root/DataFunctions/ChartFns";
import { useParams } from "react-router-dom";
import GlobalContext from "root/Contexts/GlobalContext";

const TeacherRAGReportPage = () =>
{
    const sessionContext = useContext( GlobalContext ) ;

    let { provider_id, academic_year } = useParams();

    const survey_type = sessionContext.getCurrentSurveyType() ;

    const [data, setData] = useState({loading: true, data: []});

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        getProviderSectionRAGReport( provider_id, 'current', survey_type, (response) =>
        {
            const returnData = getDataFromResponse(response) ;

            setData({loading: false, data: returnData})
        })
    }

    return (
            <PageBodyWrapper title='RAG Status Report' backButton={true}>
                <div className='table-section-rows'>
                   <h5>Responses Rated Red and Amber</h5>
                    <TableProviderRAGReport data={data} />
                </div>
            </PageBodyWrapper>
    )
}

export default TeacherRAGReportPage;
